import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 3v18","key":"svg-0"}],["path",{"d":"M6 11l12 -1v-4l-12 -1","key":"svg-1"}],["path",{"d":"M10 5.5v5","key":"svg-2"}],["path",{"d":"M14 6v4","key":"svg-3"}],["path",{"d":"M4 21h4","key":"svg-4"}]]

const IconWindsock = createReactComponent('outline', 'windsock', 'Windsock', __iconNode);

export default IconWindsock;